/** Tab 14: Audit Log */
import { Card, Timeline, Tag } from 'antd'
import dayjs from 'dayjs'
import { type JoiningDetail, type AuditLogRow } from '@/features/hr/joiningApi'

interface Props { detail: JoiningDetail }

function describe(row: AuditLogRow): React.ReactNode {
  if (row.from_status || row.to_status) {
    return (
      <span>
        <Tag>{row.from_status || '—'}</Tag>→ <Tag color="blue">{row.to_status || '—'}</Tag>
      </span>
    )
  }
  if (row.field_name) {
    return (
      <span>
        <code>{row.field_name}</code>: {row.old_value || '∅'} → {row.new_value || '∅'}
      </span>
    )
  }
  return row.notes || null
}

export default function AuditLogTab({ detail }: Props) {
  if (!detail.audit_log.length) {
    return <Card size="small" title="Audit Log"><em>No audit events yet.</em></Card>
  }

  return (
    <Card size="small" title="Audit Log">
      <Timeline
        items={detail.audit_log.map((row) => ({
          key: row.id,
          children: (
            <div>
              <strong>{row.event_type}</strong>
              <div>{describe(row)}</div>
              <div style={{ color: '#888', fontSize: 12 }}>
                {dayjs(row.performed_at).format('DD MMM YYYY HH:mm:ss')}
                {row.performed_by ? ` · by ${row.performed_by}` : ''}
              </div>
              {row.notes && <div style={{ color: '#666', fontSize: 12 }}>{row.notes}</div>}
            </div>
          ),
        }))}
      />
    </Card>
  )
}
